module.exports = __webpack_public_path__ + "static/p4-6f4e372baca7cd706f3625914e57230b.jpg";